import { CheckCircle2, Eye, Link2Off, Printer } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { printPdfBlob } from "@/lib/printPdf";
import { errText, fetchBlob, isPdf } from "./resourceApi";

const btn = "p-1.5 rounded-md hover:bg-zinc-100 text-zinc-500";

async function issuedBlob(id) {
  return fetchBlob(`/resource-assignments/${id}/file`, { preview: true });
}

/** Timeline actions for a sent resource — always the exact version the client received. */
export function AssignmentRowActions({ item, canAct }) {
  const m = item.meta || {};
  const linkActive = m.method === "email" && !m.link_revoked_at && (m.link_expires_at || "") > new Date().toISOString();
  const refresh = () => window.dispatchEvent(new CustomEvent("hr-refresh"));

  async function view() {
    try {
      const url = URL.createObjectURL(await issuedBlob(item.id));
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { toast.error("Could not open the issued version", { description: errText(e) }); }
  }
  async function print() {
    try {
      const blob = await issuedBlob(item.id);
      if (!isPdf(blob.type)) return view();
      await printPdfBlob(new Blob([blob], { type: "application/pdf" }));
    } catch (e) { toast.error("Print failed", { description: errText(e) }); }
    return null;
  }
  async function provided() {
    try { await api.post(`/resource-assignments/${item.id}/provided`, { note: "" }); toast.success("Marked as given to the client"); refresh(); }
    catch (e) { toast.error("Could not update", { description: errText(e) }); }
  }
  async function revoke() {
    if (!window.confirm("Turn off this private link? The client won't be able to open it any more.")) return;
    try { await api.post(`/resource-assignments/${item.id}/revoke-link`); toast.success("Link turned off"); refresh(); }
    catch (e) { toast.error("Could not turn off link", { description: errText(e) }); }
  }

  return (
    <>
      {m.method === "email" && (
        <span className="mr-1 text-2xs text-zinc-500" data-testid={`hr-assignment-opens-${item.id}`}>
          {["failed", "not_sent"].includes(m.delivery_status) ? "not delivered" : m.link_revoked_at ? "link off"
            : linkActive ? `opened ${m.link_opened_count || 0}×` : "link expired"}
        </span>
      )}
      <button onClick={view} className={btn} title={`View issued version v${m.version_number}`} data-testid={`hr-assignment-view-${item.id}`}>
        <Eye className="h-3.5 w-3.5" /></button>
      {m.method === "print" && (
        <button onClick={print} className={btn} title="Print again" data-testid={`hr-assignment-print-${item.id}`}>
          <Printer className="h-3.5 w-3.5" /></button>
      )}
      {canAct && m.method === "print" && !m.provided_at && (
        <button onClick={provided} className={btn} title="Mark as given to the client" data-testid={`hr-assignment-provided-${item.id}`}>
          <CheckCircle2 className="h-3.5 w-3.5" /></button>
      )}
      {canAct && linkActive && (
        <button onClick={revoke} className="p-1.5 rounded-md hover:bg-red-50 text-red-600" title="Turn off private link"
                data-testid={`hr-assignment-revoke-${item.id}`}><Link2Off className="h-3.5 w-3.5" /></button>
      )}
    </>
  );
}
